import ColorDot from './ColorDot';
export default ColorDot;
